import React from "react"

/* Dashboard */
export const CompletionSteps = React.lazy(() => import("./CompletionSteps"))

/* Layout */
export const Layout = React.lazy(() => import("./Layout"))
export const AuthLayout = React.lazy(() => import("./AuthLayout"))

/* Charts */
export const PieChart = React.lazy(() => import("./Charts/PieChart"))
export const PieCustom = React.lazy(() => import("./Charts/PieCustom"))

//table check boxes
export { default as CheckBoxes } from "./Table/CheckBoxes"

/* WALLET CARD */
export const WalletCards = React.lazy(() => import("./WalletCards/WalletCards"))

export const QR = React.lazy(() => import("./QRGenerator/QR"))

// DIALOGS
export const ParentDialog = React.lazy(() => import("./Dialogs/ParentDialog"))
export const ParentDialogLG = React.lazy(
    () => import("./Dialogs/ParentDialogLG")
)

//Progress
export { default as LineProgress } from "./Progress/LineProgress"

//OTP
export const OTP = React.lazy(() => import("./OTP-Popup/OTP"))

//PreLoader
export { default as PreLoader } from "./PreLoader"

// DROP ITEMS
export const DropItem = React.lazy(() => import("./DropItem/DropItem"))

export const RuntimeCheck = React.lazy(() => import("./RuntimeCheck"))
